/**
 * Contact Form functionality
 */

export function initContactForm() {
    // Set data-label attributes for persistent labels with custom values
    const labelMap = {
        'nom-prenom': 'Nom Prénom',
        'societe': 'Société', 
        'email': 'E-mail',
        'telephone': 'Tél.',
        'message': 'Message',
        'cv': 'CV',
        'lettre': 'Motivation'
    };
    
    function setLabels() {
        const formFields = document.querySelectorAll('.form-field');
        
        formFields.forEach(field => {
            const input = field.querySelector('.form-input, .form-textarea');
            if (input && input.name) {
                    // Use the regular label map for other inputs
                    const label = labelMap[input.name] || input.name;
                    field.setAttribute('data-label', label);
            }
        });
        
        // Set placeholders for file inputs
        const fileInputs = document.querySelectorAll('input[type="file"]');
        fileInputs.forEach((input) => {
                input.setAttribute('placeholder', 'Joindre un fichier');
        });
    }
    
    function bindFileFields() {
        const fileFields = document.querySelectorAll('.file-field input[type="file"]');
        fileFields.forEach((input) => {
            if (input.dataset.hasFileBound) return;
            input.dataset.hasFileBound = 'true';

            input.addEventListener('change', () => {
                const label = input.closest('label');
                if (!label) return;
                label.classList.toggle('has-file', input.files && input.files.length > 0);
            });
        });
    }

    function bindSubmitProtection() {
        document.querySelectorAll('form.wpcf7-form').forEach((form) => {
            if (form.dataset.submitGuardBound) return;
            form.dataset.submitGuardBound = 'true';

            const submitBtn = form.querySelector('.contact-form-submit');
            if (!submitBtn) return;

            const textEl = submitBtn.querySelector('span') || submitBtn;
            const originalText = textEl.textContent;

            const lock = () => {
                submitBtn.setAttribute('disabled', 'disabled');
                submitBtn.classList.add('is-submitting');
                textEl.textContent = 'Envoi…';
            };

            const unlock = () => {
                submitBtn.removeAttribute('disabled');
                submitBtn.classList.remove('is-submitting');
                textEl.textContent = originalText;
            };

            // Prevent further clicks once locked
            submitBtn.addEventListener('click', (e) => {
                if (submitBtn.hasAttribute('disabled')) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                }
            }, true);

            // Lock as soon as the form starts submitting
            form.addEventListener('submit', () => {
                queueMicrotask(lock);
            });

            // CF7 dispatches wpcf7submit on every outcome (success/error/invalid/spam)
            form.addEventListener('wpcf7submit', unlock);

            // Safety net if CF7 never dispatches (e.g. network failure)
            form.addEventListener('wpcf7mailfailed', unlock);
        });
    }

    // Run immediately
    setLabels();
    bindFileFields();
    bindSubmitProtection();

    // Also run when popup opens
    document.addEventListener('click', function(e) {
        if (e.target.closest('#contactBtn') || e.target.closest('a[href="#contact"]')) {
            setTimeout(() => {
                setLabels();
                bindFileFields();
                bindSubmitProtection();
            }, 100);
        }
    });

    // Reset state after a successful CF7 submit
    document.addEventListener('wpcf7mailsent', () => {
        document.querySelectorAll('.file-field label.has-file').forEach((label) => {
            label.classList.remove('has-file');
        });
    });
}